import type { PaletteOptions } from "@mui/material/styles";

export const lightPalette: PaletteOptions = {
	background: {
		default: "#FFFFFF",
	},
	text: {
		primary: "#1B1B1B",
		soft: "#666666",
		disabled: "#999999",
	},
	primary: {
		main: "#000000",
	},
	secondary: {
		main: "#FFFFFF",
	},
	info: {
		main: "#0288d1",
		light: "#29b6f6",
		dark: "#01579b",
		contrastText: "#FFFFFF",
		border: "#b3e5fc",
		background: "#e1f5fe",
	},
	success: {
		main: "#388e3c",
		light: "#66bb6a",
		dark: "#1b5e20",
		contrastText: "#FFFFFF",
		border: "#c8e6c9",
		background: "#e8f5e9",
	},
	warning: {
		main: "#f57c00",
		light: "#ff9800",
		dark: "#e65100",
		contrastText: "#FFFFFF",
		border: "#ffcc80",
		background: "#fff3e0",
	},
	error: {
		main: "#d32f2f",
		light: "#f44336",
		dark: "#b71c1c",
		contrastText: "#FFFFFF",
		border: "#ef9a9a",
		background: "#ffebee",
	},
	divider: "#E0E0E0",

	// Custom colors
	gradients: {
		muted: {
			toBottom: "linear-gradient(to bottom, #FAFAFA 0%, #EAEAEA 100%)",
			toTop: "linear-gradient(to top, #FAFAFA 0%, #EAEAEA 100%)",
		},
		primary: {
			main: "linear-gradient(to bottom, #000000 0%, #3A3A3A 100%)",
			reverse: "linear-gradient(to top, #000000 0%, #3A3A3A 100%)",
		},
		onboarding: "radial-gradient(#FAFAFA 60%, transparent)",
		signUp: "radial-gradient(#000000 40%, transparent)",
		docs: "linear-gradient(to bottom, #FAFAFA 0%, #EAEAEA 100%)",
		audiences: {
			toBottom: "linear-gradient(to bottom, #0051C8 0%, #00388c 100%)",
			bottomRight: "linear-gradient(to bottom right, #2C81FF 0%, #0051C8 100%)",
		},
		subscription: {
			// The following gradient aligns with the updated design tokens for the starter subscription tier.
			starter: {
				background:
					"linear-gradient(to bottom, rgba(0, 81, 200, 0.1) 0%, rgba(0, 81, 200, 0) 100%)",
				radial: "radial-gradient(#0051C8 40%, #00388c 100%)",
				toBottom: "linear-gradient(to bottom, #0051C8 0%, #00388c 100%)",
				toTopRight: "linear-gradient(20deg, #0051C8 0%, #FFFFFF 70%)",
			},
			essentials: {
				// The following gradient aligns with the updated design tokens for the essentials subscription tier.
				background:
					"linear-gradient(to bottom, rgba(19, 191, 77, 0.1) 0%, rgba(19, 191, 77, 0) 100%)",
				radial: "radial-gradient(#13BF4D 40%, #089035 100%)",
				toBottom: "linear-gradient(to bottom, #13BF4D 0%, #089035 100%)",
				toTopRight: "linear-gradient(20deg, #13BF4D 0%, #FFFFFF 70%)",
			},
			premium: {
				// The following gradient aligns with the updated design tokens for the premium subscription tier.
				background:
					"linear-gradient(to bottom, rgba(255, 170, 0, 0.1) 0%, rgba(255, 170, 0, 0) 100%)",
				radial: "radial-gradient(#ff8f00 40%, #DE6F00 100%)",
				toBottom: "linear-gradient(to bottom, #ff8f00 0%, #DE6F00 100%)",
				toTopRight: "linear-gradient(20deg, #ff8f00 0%, #FFFFFF 70%)",
			},
		},
	},
	border: "#CCCCCC",
	muted: {
		main: "#F8F8F8",
		light: "#fafafa",
		dark: "#EAEAEA",
	},
	audiences: {
		main: "#0051C8",
		light: "#2C81FF",
		dark: "#00388c",
		contrastText: "#F8F8F8",
		background: "#E5F0FF",
	},
	creators: {
		main: "#7600EB",
		light: "#9133ef",
		dark: "#5200a4",
		contrastText: "#F8F8F8",
		background: "#f3e5f5",
	},
	knowledge: {
		main: "#00591E",
		light: "#337a4b",
		dark: "#003e15",
		contrastText: "#F8F8F8",
		background: "#E5FFEE",
	},
	starter: {
		main: "#0051C8",
		light: "#2C81FF",
		dark: "#00388c",
		contrastText: "#F8F8F8",
	},
	essentials: {
		main: "#13BF4D",
		light: "#42cb70",
		dark: "#089035",
		contrastText: "#F8F8F8",
	},
	premium: {
		main: "#ff8f00",
		light: "#ffbb33",
		dark: "#DE6F00",
		contrastText: "#F8F8F8",
	},
};
